// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.9c2f818b568b963462aeca498cf8220663b879da.js";
};